<template>
    <section  v-if="mounted" class="IndustryHero bg--grey-light">
        <div class="IndustryHero__container container py-medium desk-py-large">
            <BaseImage
                v-if="image"
                classes="BaseImage--ImageText"
                :placeholder="placeholder"
                :srcset="image"
                :ratio="1"
            />

            <div
                class="IndustryHero__text"
            >

                <BaseHeading
                    :heading="heading"
                    tag="h3"
                    class="noline"
                />

                <BaseText
                    :text="text"
                    class="mt-spacer mb-medium"
                />

                <div>
                    <BaseButton
                        v-if="button"
                        :href="url"
                    >
                        {{ button }}
                    </BaseButton>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: 'IndustryHero',
    props: {
        heading: {
            type: String,
            default: null,
        },
        preheading: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        image: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        button: {
            type: String,
            default: null,
        },
        url: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            mounted: false
        }
    },
    mounted() {
        this.mounted = true;
    }
}
</script>
<style lang="scss">

    .IndustryHero__container {
        display: flex;

        @include media-query(palm) {
            flex-direction: column;
        }
    }



    .IndustryHero__image {
        object-fit: cover;
        width: 100%;
        max-height: 280px;
        box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);

        @include media-query(lap-and-up) {
            width: 50%;
            max-height: unset;
        }
    }


    .IndustryHero__text {
        padding: getSpacing('medium') 0;

        @include media-query(lap-and-up) {
            width: 50%;
            padding: getSpacing('medium');
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-right: 0;
        }

        @include media-query(desk) {
            padding: getSpacing('large');
            padding-right: 0;
        }
    }
</style>
